<script>
    import { VIEWER_HEIGHT } from '../constants';
    import { currentImage } from '../store';

    let displayFull = false;
    const toggleDisplayFull = () => {
      displayFull = !displayFull;
    };

    let position = '50% 50%';
    const onMove = ({clientX, clientY}) => {
        const {x, y, width, height} = document.querySelector('#viewer').getBoundingClientRect();
        const xPos = (clientX - x) / width * 100;
        const yPos = (clientY - y) / VIEWER_HEIGHT * 100;

        position = `${xPos}% ${yPos}%`;
    }
</script>

<div id="viewer" class="viewer" on:mouseenter={toggleDisplayFull}>
    <img src={$currentImage.medium} width="100%" alt="" />
    {#if displayFull}
        <div
            class="fullViewer"
            on:mousemove={onMove}
            on:mouseleave={toggleDisplayFull}
            style="background-image: url({$currentImage.hd}); background-position: {position};"
        />
    {/if}
</div>

<style>
.viewer {
    position: relative; width: 100%; height: 100%; overflow: hidden;
}

.fullViewer {
    position: absolute; top: 0; right: 0; bottom: 0; left: 0;
}

img {
    display: block;
}
</style>
